<script>
import Vue from 'vue'
import DibbleTranslation from "../../translation/translation";
import DibbleJS from "../../dibble";
// import UserRoles from "../../DefinedData/UserRoles";
// import UserMenuRoleModuleAssignment from "../../utils/UserMenuRoleAssignments";
import DibbleAPI from "../../api";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import ModalVerifyProgress
    from "@/components/Dashboard/sub-components/ModalVerifyProgress.vue";

Vue.use(Donut);
export default {
    name: "Dashboard",
    components: {ModalVerifyProgress},
    display: "Transition",
    data() {
        return {
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            dashboardData: null,
            sections: [{ value: 75, color: 'red' }, { value: 25, color: 'green' }],
            topCharts: [],
            sizeCircle: 150,
            sizeThickness: 15,
        }
    },
    watch: {
        dashboardData: {
            handler: function (val) {
                if (val !== null) {
                    this.topCharts = [
                        {
                            value: {
                                value: this.dashboardData.active_percent,
                                color: '#1F78B4',
                                name: 'Active'
                            },
                            label: 'Active',
                        },
                        {
                            value: {
                                value: this.dashboardData.inactive_percent,
                                color: '#2c94ab',
                                name: 'Inactive'
                            },
                            label: 'Inactive',
                        },
                        {
                            value: {
                                value: this.dashboardData.completed_percent,
                                color: '#A6CEE3',
                                name: 'Complete'
                            },
                            label: 'Complete',
                        },
                        {
                            value: {
                                value: this.dashboardData.event_percent,
                                color: '#5d5fef',
                                name: 'Events'
                            },
                            label: 'Events',
                        },
                    ]
                }
            },
            deep: true,
        },
    },
    mounted() {},
    created() {
        window.addEventListener("resize", this.resize);
        this.getDashboardData()
    },
    methods: {
        getDashboardData() {
            DibbleJS.showLoader()
            const params = {
                '#request': DibbleAPI.api.getDashboardData
            }
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.dashboardData = responseData
                } else {
                    DibbleJS.toastErrorMessage(responseData.message)
                }
            })
        },
        resize () {
            if (window.innerWidth < 1400) {
                this.sizeCircle = 100
                this.sizeThickness = 10
            } else {
                this.sizeCircle = 150
                this.sizeThickness = 15
            }
        }
    }
}
</script>
<template src="./template/index.html"></template>
<style lang="scss" scoped>
    .product-image {
        width: 50px;
        height: 55px;
    }

    .line-link:before {
        right: 30px;
    }
    .rental-boasts {
        p {
            font-family: 'Open Sans';
            font-style: normal;
        }
        border-radius: 40px;
        box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
        background: #F3F6F7;
        padding: 25px 25px 0 25px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        width: 70%;
        .text-header {
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0.04em;
            color: #555E67;
        }
        .title-rental {
            border-bottom: 1.5px solid #DEE6EA;
            height: 35px;
            p {
                color: #2278aa;
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 0;
                letter-spacing: 0.04em;
                padding-left: 10px;
            }
        }
        .first-session {
            padding-top: 20px;
            padding-bottom: 20px;
            margin-bottom: 40px;
            border-bottom: 1.5px solid #DEE6EA;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            .chart-circle {
                display: flex;
                align-items: center;
                flex: 1;
                justify-content: space-around;
                .text-percent {
                    font-size: 3rem;
                    color: #555E67;
                    font-weight: 500;
                }
                .text-status {
                    font-size: 1rem;
                    color: #555E67;
                }
            }
        }
        .second-session {
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
            border-bottom: 1.5px solid #DEE6EA;
            padding-bottom: 30px;
            .text-income {
                font-size: 16px;
                color: #40b8dc;
                font-weight: 600;
                text-align: right;
            }
            table {
                margin-top: 20px;
                width: 100%;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 40px;
                background: #F5F5F5;
                tr {
                    &:not(:last-child) {
                        border-bottom: 1.5px solid #DEE6EA;
                    }
                    td {
                        &:nth-child(1) {
                            padding-left: 20px;
                        }
                        &:last-child {
                            padding-right: 20px;
                        }
                        padding-bottom: 10px;
                        padding-top: 10px;
                    }
                }
            }
        }
        .third-session {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
            padding-top: 20px;
            .status-boats {
                margin-top: 20px;
                margin-bottom: 0px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex: 1;
                .status {
                    width: 25%;
                    height: 70px;
                    background: #C2D8DD;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-radius: 30px;
                    box-shadow: 0px 6px 10px 2px rgba(204,204,204,0.63);
                    .text-status {
                        margin: 0;
                        font-size: 20px;
                        color: #555E67;
                    }
                    .number {
                        font-weight: bold;
                        margin: 0;
                        font-size: 20px;
                        color: #555E67;
                    }
                }
                .status-available {
                    background: #1C5169 !important;
                    p {
                        color: #fff !important;
                        line-height: 27px;
                        text-align: center;
                    }
                }
            }
            .img-boat {
                width: 40px;
                margin-left: 15px;
            }
        }
        // moorage
        .content-moorage {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            box-sizing: border-box;
            .moorage-row {
                margin: 0 -25px;
                background: #E8EFF1;
                border-radius: 40px;
                padding: 10px 25px 20px;
                display: flex;
                flex-direction: column;
                &:not(:first-child) {
                    margin-top: 30px;
                }
                .title-moorange {
                    height: 30px;
                    line-height: 30px;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }
                .slips-column {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    span {
                        font-size: 40px;
                        color: #555E67;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 300;
                    }
                    img {
                        width: 20px;
                    }
                }
                .list-available {
                    display: flex;
                    flex: 1;
                    .available-status {
                        background: #1C5169;
                        width: 50%;
                        height: 80px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-radius: 30px;
                        box-shadow: 0px 6px 10px 2px rgba(204,204,204,0.63);
                        p {
                            color: #fff;
                        }
                        .number {
                            font-size: 30px;
                            font-weight: bold;
                        }
                        .status {
                            font-size: 16px;
                        }
                    }
                    .unavailable-status {
                        background: #C2D8DD;
                        width: 50%;
                        height: 80px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-radius: 30px;
                        box-shadow: 0px 6px 10px 2px rgba(204,204,204,0.63);
                        p {
                            color: #555;
                        }
                        .number {
                            font-size: 30px;
                            font-weight: bold;
                        }
                        .status {
                            font-size: 16px;
                        }
                    }
                }
                .income-chart {
                    flex: 1;
                    box-sizing: border-box;
                    margin-top: 1rem;
                }
            }

        }
    }

    .border-none {
        border-bottom: none !important;
    }

    // @media (max-width: 750px){
    //     .rental-boasts {
    //         width: 100% !important;
    //         max-width: 100% !important;
    //         flex: 0 0 100% !important;
    //         .slips-column {
    //             width: 30% !important;
    //         }
    //         &:not(:last-child) {
    //             margin-bottom: 10px;
    //         }
    //     }
    // }
    @media only screen and (min-width: 701px) and (max-width: 1400px) {
        .slips-column {
            width: 30% !important;
            span {
                font-size: 25px !important;
            }
        }
        .available-status, .unavailable-status {
            .number {
                font-size: 25px !important;
            }
            .status {
                font-size: 13px !important;
            }
        }
        .text-percent {
            font-size: 2rem !important;
        }
        .rental-boasts {
            margin-top: 20px !important;
        }
        .status-boats {
            .status {
                p {
                    font-size: 14px !important;
                }
            }
        }
    }
    @media only screen and (max-width: 700px) {
        .rental-boasts {
            width: 100% !important;
            max-width: 100% !important;
            flex: 0 0 100% !important;
            .slips-column {
                width: 30% !important;
                span {
                    font-size: 25px !important;
                }
            }
            margin-top: 20px !important;
        }
        .text-percent {
            font-size: 2rem !important;
        }
        .status-boats {
            .status {
                p {
                    font-size: 14px !important;
                }
            }
        }
    }
</style>
